module.exports = __webpack_public_path__ + "img/settings.4d77983b.svg";